export default __webpack_public_path__ + "static/media/drive.ef774479.svg";